//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'range-time',
  props: {
    min: {
      default: ''
    },
    max: {
      default: ''
    }
  },
  data: function data() {
    return {
      value: ''
    };
  },
  watch: {
    value: {
      deep: true,
      handler: function handler() {
        this.$emit('update:min', this.value[0]);
        this.$emit('update:max', this.value[1]);
      }
    },
    min: function min() {
      this.value = [this.min, this.max];
    },
    max: function max() {
      this.value = [this.min, this.max];
    }
  }
};